var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropdownRecord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    d: "M25 37C31.6274 37 37 31.6274 37 25C37 18.3726 31.6274 13 25 13C18.3726 13 13 18.3726 13 25C13 31.6274 18.3726 37 25 37Z",
    fill: "url(#paint0_linear_18939_8807)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    d: "M25 37C31.6274 37 37 31.6274 37 25C37 18.3726 31.6274 13 25 13C18.3726 13 13 18.3726 13 25C13 31.6274 18.3726 37 25 37Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 40C33.2843 40 40 33.2843 40 25C40 16.7157 33.2843 10 25 10C16.7157 10 10 16.7157 10 25C10 33.2843 16.7157 40 25 40ZM25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25C7 34.9411 15.0589 43 25 43Z",
    fill: "url(#paint1_linear_18939_8807)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 40C33.2843 40 40 33.2843 40 25C40 16.7157 33.2843 10 25 10C16.7157 10 10 16.7157 10 25C10 33.2843 16.7157 40 25 40ZM25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25C7 34.9411 15.0589 43 25 43Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    d: "M25 37C31.6274 37 37 31.6274 37 25C37 18.3726 31.6274 13 25 13C18.3726 13 13 18.3726 13 25C13 31.6274 18.3726 37 25 37Z",
    fill: "url(#paint0_linear_18872_8529)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    d: "M25 37C31.6274 37 37 31.6274 37 25C37 18.3726 31.6274 13 25 13C18.3726 13 13 18.3726 13 25C13 31.6274 18.3726 37 25 37Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 40C33.2843 40 40 33.2843 40 25C40 16.7157 33.2843 10 25 10C16.7157 10 10 16.7157 10 25C10 33.2843 16.7157 40 25 40ZM25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25C7 34.9411 15.0589 43 25 43Z",
    fill: "url(#paint1_linear_18872_8529)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 40C33.2843 40 40 33.2843 40 25C40 16.7157 33.2843 10 25 10C16.7157 10 10 16.7157 10 25C10 33.2843 16.7157 40 25 40ZM25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25C7 34.9411 15.0589 43 25 43Z",
    fill: "white",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18939_8807",
    x1: 10.9724,
    y1: 12.25,
    x2: 49.0514,
    y2: 15.8641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18939_8807",
    x1: 10.9724,
    y1: 12.25,
    x2: 49.0514,
    y2: 15.8641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18872_8529",
    x1: 10.9724,
    y1: 12.25,
    x2: 49.0514,
    y2: 15.8641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18872_8529",
    x1: 10.9724,
    y1: 12.25,
    x2: 49.0514,
    y2: 15.8641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333139"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownRecord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropdown-record.e88558743acddd5e2215ce55de3d96fd.svg";